import React, { useState, useEffect } from 'react';
import { BrandOutlinedButton, ThemePrimaryButton } from '../button';
import {
  Box,
  Typography,
  Paper,
  Link,
  Snackbar,
  Slide,
  Stack
} from '@mui/material';
import { useNavigate } from 'react-router-dom';
import cookieManager from '../../utils/cookieManager';
import CookieIcon from '@mui/icons-material/Cookie';
import CookiePreferencesFields from '../common/CookiePreferencesFields';
import CookieSettingsDialogChrome from '../common/CookieSettingsDialogChrome';
import { acme } from '../../theme/acmeTheme';

const CookieConsent = () => {
  const [open, setOpen] = useState(false);
  const [dialogOpen, setDialogOpen] = useState(false);
  const navigate = useNavigate();

  const [cookiePreferences, setCookiePreferences] = useState(cookieManager.getCookiePreferences());

  useEffect(() => {
    if (!cookieManager.hasConsent()) {
      setOpen(true);
    }
  }, []);

  const handleAcceptAll = () => {
    const allAccepted = {
      essential: true,
      analytics: true,
      functional: true,
      targeting: true
    };

    cookieManager.saveCookiePreferences(allAccepted);
    setOpen(false);
  };

  const handleAcceptSelected = () => {
    cookieManager.saveCookiePreferences(cookiePreferences);
    setDialogOpen(false);
    setOpen(false);
  };

  const handleViewPolicy = () => {
    navigate('/privacy-policy');
    setOpen(false);
    setDialogOpen(false);
  };

  const handleOpenSettings = () => {
    setDialogOpen(true);
  };

  const handleCloseDialog = () => {
    setDialogOpen(false);
  };

  const handlePreferenceChange = (event) => {
    setCookiePreferences({
      ...cookiePreferences,
      [event.target.name]: event.target.checked
    });
  };

  function SlideTransition(props) {
    return <Slide {...props} direction="up" />;
  }

  return (
    <>
      <Snackbar
        open={open}
        anchorOrigin={{ vertical: 'bottom', horizontal: 'center' }}
        TransitionComponent={SlideTransition}
      >
        <Paper
          elevation={3}
          sx={{
            p: 2,
            maxWidth: '600px',
            width: '100%',
            display: 'flex',
            flexDirection: 'column',
            gap: 2,
            borderRadius: 2
          }}
        >
          <Box sx={{ display: 'flex', alignItems: 'center', gap: 1 }}>
            <CookieIcon sx={{ color: acme.colors.brand }} />
            <Typography variant="subtitle1" fontWeight="bold">
              Welcome to Mailsball
            </Typography>
          </Box>

          <Typography variant="body2">
            We use cookies to improve your browsing experience and analyze user activity. By continuing to use our site, you agree to our{' '}
            <Link
              component="button"
              variant="body2"
              onClick={handleViewPolicy}
              underline="hover"
            >
              privacy policy
            </Link>
            .
          </Typography>

          <Stack
            direction={{ xs: 'column', sm: 'row' }}
            spacing={1}
            justifyContent="flex-end"
          >
            <BrandOutlinedButton
              onClick={handleOpenSettings}
              sx={{ minWidth: '120px' }}
            >
              Settings
            </BrandOutlinedButton>
            <ThemePrimaryButton
              onClick={handleAcceptAll}
              sx={{ fontWeight: 'bold', minWidth: '120px' }}
            >
              Accept All
            </ThemePrimaryButton>
          </Stack>
        </Paper>
      </Snackbar>

      <CookieSettingsDialogChrome
        open={dialogOpen}
        onClose={handleCloseDialog}
        onViewPolicy={handleViewPolicy}
        onSave={handleAcceptSelected}
      >
        <CookiePreferencesFields
          preferences={cookiePreferences}
          onPreferenceChange={handlePreferenceChange}
        />
      </CookieSettingsDialogChrome>
    </>
  );
};

export default CookieConsent;
